import React from 'react'
import HistoryScreeningTable from './ScreeningTableComponent/HistoryscreeningTable'



const ScreeningHistory = () => {
    return (
        <div>
            <HistoryScreeningTable
                pageHeader={"Screening / History"}
                headerTitles={[
                    "Update",
                    "Title",
                    "Applicant Name",
                    "Job Profile",
                    "Applied On",
                    "Status",
                    "Phone Number",
                    "Stage",
                    "Work Experience",
                    "Email",
                    "Location",
                    "Replace ID"
                ]}
                setData={undefined} />

        </div>
    )
}

export default ScreeningHistory
